// extracted by mini-css-extract-plugin
module.exports = {"rotatingMessage":"RotatingMessage_rotatingMessage__22kxV"};